import { SonarText } from '@ui/text';
import React from 'react';
export const BulkEditModalSection = ({ children, title }) => React.createElement("div", { className: 'bulk-edit-modal-section' },
    React.createElement(SonarText, { weight: 'semibold' }, title),
    children);
